import {
  useState,
  useEffect,
  useRef,
  memo,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import Svg from 'UI/components/Svg';
import { SVG_IMAGES_TYPES } from 'utils/constants';
import { useRouter } from 'next/router';
import styles from './styles.module.scss';

const SearchInput = ({
  inputRef,
  inputValue,
  setInputValue,
  onClose,
  withClear = false,
}) => {
  const router = useRouter();

  const handleSearch = useCallback(() => {
    if (!inputValue.trim()) return;

    router.push(`/search/${encodeURIComponent(inputValue)}`);

    if (onClose) {
      onClose();
      setInputValue('');
    }
  }, [inputValue]);

  const handleOnChangeInput = ({ target: { value } }) => {
    setInputValue(value);
  };

  const handleClearValue = () => {
    setInputValue('');
  };

  const handleOnCloseModalWindow = useCallback(() => {
    if (onClose) {
      onClose();
      setInputValue('');
    }
  }, [onClose, setInputValue]);

  useEffect(() => {
    const handleOnKeyDown = ({ key }) => {
      if (key === 'Escape') {
        handleOnCloseModalWindow();
      }

      if (key === 'Enter') {
        handleSearch();
      }
    };

    document.addEventListener('keydown', handleOnKeyDown);

    return () => document.removeEventListener('keydown', handleOnKeyDown);
  }, [handleOnCloseModalWindow, handleSearch]);

  return (
    <div className={styles.inputContainer}>
      <Svg
        type={SVG_IMAGES_TYPES.searchLg}
        handleOnClick={handleSearch}
        className={styles.searchIcon}
      />
      <input
        ref={inputRef}
        className={styles.input}
        type="text"
        placeholder="Find all you need (e.g. services, blog, news, contact info)"
        onChange={handleOnChangeInput}
        value={inputValue}
      />
      {withClear && (
        <Svg
          type={SVG_IMAGES_TYPES.closeSvg}
          handleOnClick={handleClearValue}
          className={styles.searchIcon}
        />
      )}
    </div>
  );
};

SearchInput.defaultProps = {
  isFullscreenSearch: false,
};

SearchInput.propTypes = {
  isFullscreenSearch: PropTypes.bool,
  closeFullscreenSearch: PropTypes.func.isRequired,
};

export default memo(SearchInput);
